import { ResourceGuesser } from '@api-platform/admin'
import Admin from './Admin'
import PeopleIcon from '@mui/icons-material/People'
import AdIcon from '@mui/icons-material/ChecklistRtl'
import PercentIcon from '@mui/icons-material/Percent'
import CategoryIcon from '@mui/icons-material/Category'
import CommuneIcon from '@mui/icons-material/ShareLocation'
import CheckIcon from '@mui/icons-material/Check'
import LocationCityIcon from '@mui/icons-material/LocationCity'
import CountryIcon from '@mui/icons-material/Flag'
import MarqueIcon from '@mui/icons-material/EmojiTransportation'
import EquipmentIcon from '@mui/icons-material/LocalCarWash'
import ModelIcon from '@mui/icons-material/CarRepair'
import JobDomainIcon from '@mui/icons-material/Work'
import CRUD from './resources/Crud'
import Town from './resources/Town'
import Deal from './resources/Deal'
import User from './resources/User'
import Commune from './resources/Commune'
import Certification from './resources/Certification'
import Category from './resources/Category'
import Ad from './resources/Ad'
import Model from './resources/Model'

const App = () => {
    return (
        <Admin>
            <ResourceGuesser icon={AdIcon} options={{ label: 'Ads' }} name='ads' {...Ad} />
            <ResourceGuesser icon={PercentIcon} options={{ label: 'Deals' }} name='deals' {...Deal} />
            <ResourceGuesser icon={PeopleIcon} options={{ label: 'Users' }} name='users' {...User} />

            <ResourceGuesser icon={CategoryIcon} options={{ label: 'Categories' }} name='categories' {...Category} />
            <ResourceGuesser icon={JobDomainIcon} options={{ label: 'Domains' }} name='domains' {...CRUD} />

            <ResourceGuesser icon={MarqueIcon} options={{ label: 'Marques' }} name='marques' {...CRUD} />
            <ResourceGuesser icon={ModelIcon} options={{ label: 'Models' }} name='models' {...Model} />
            <ResourceGuesser icon={EquipmentIcon} options={{ label: 'Equipment' }} name='equipment' {...CRUD} />

            <ResourceGuesser icon={CountryIcon} options={{ label: 'Countries' }} name='countries' {...CRUD} />
            <ResourceGuesser icon={LocationCityIcon} options={{ label: 'Towns' }} name='towns' {...Town} />
            <ResourceGuesser icon={CommuneIcon} options={{ label: 'Communes' }} name='communes' {...Commune} />

            <ResourceGuesser icon={CheckIcon} options={{ label: 'Certifications' }} name='certifications'{...Certification} />
        </Admin>
    )
}

export default App
